import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('daywise_opening_stock')
export class DaywiseOpeningStockEntity{
    @PrimaryGeneratedColumn('increment', {name: 'id'})
    id: number;

    @Column('int',{
        name:'variant_id',
    })
    variantId: string

    @Column('int',{
        name:'pack_style_id',
    })
    packStyleId: number

    @Column('int',{
        name:'cartons',
    })
    cartons: number

    @Column('decimal',{
        name:'loose_pouches',
        precision:10,scale:3
    })
    loosePouches: number

    @Column('decimal',{
        name:'opening_stock_kgs',
        precision:10,scale:3,
        unsigned:true
    })
    openingStockKgs: number

    @Column('datetime',{
        name:'date'
    })
    date: Date

    @Column('int',{
        name:'plant_id'
    })
    plantId: number

    @Column('varchar',{
        name:'product_category',
        nullable:false,
        length : 20
    })
    productCategory: string


}